<div class="report-page">
  <div class="report-page__header">
    <span class="report-page__title flex justify-start items-center text-black font-black uppercase">
      Relatórios de atendimentos
    </span>

    <div class="filters-toolbar">
      <div class="filters-toolbar__field">
        <select
          class="w-full form-select form-select-lg text-white font-medium bg-blumine"
          aria-label="Ordenar relatórios"
          [formControl]="orderControl"
        >
          <option *ngFor="let order of listOrder" [ngValue]="order.value">{{ order.label }}</option>
        </select>
      </div>

      <div class="filters-toolbar__field filters-toolbar__field--date">
        <mat-form-field appearance="fill" class="date-range-filter">
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input
              matStartDate
              formControlName="start"
              placeholder="Busque por data"
              (dateChange)="onStartDateChange($event)"
            />
            <input matEndDate formControlName="end" placeholder="" (dateChange)="onEndDateChange($event)" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida</mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
        </mat-form-field>
      </div>

      <div class="filters-toolbar__field" *ngIf="canFilterByCompany">
        <select
          class="w-full form-select form-select-lg text-white font-medium bg-blumine"
          aria-label="Filtrar por empresa"
          [formControl]="companyControl"
        >
          <option [ngValue]="null">Todas empresas</option>
          <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.name }}</option>
        </select>
      </div>

      <div class="filters-toolbar__field" *ngIf="canFilterByAttendant">
        <select
          class="w-full form-select form-select-lg text-white font-medium bg-blumine"
          aria-label="Filtrar por atendente"
          [formControl]="attendantControl"
        >
          <option [ngValue]="null">Todos atendentes</option>
          <option *ngFor="let attendant of attendants" [ngValue]="attendant.id">{{ attendant.name }}</option>
        </select>
      </div>

      <div class="filters-toolbar__field filters-toolbar__field--search">
        <input
          [formControl]="acaoInput"
          type="text"
          class="form-input w-full"
          placeholder="Pesquise por Nome ou Protocolo"
        />
      </div>

      <div class="filters-toolbar__actions">
        <button
          (click)="getAttendanceReports()"
          title="Filtrar atendimentos"
          class="filters-toolbar__action btn btn--secondary h-35"
        >
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="Filtrar" />
        </button>

        <button
          (click)="cleanFilter()"
          title="Limpar filtros"
          class="filters-toolbar__action btn btn--primary h-35 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="Limpar filtros" />
        </button>

        <button
          *isAllowed="[ERoleAdminString.Admin, 'reports.download']"
          class="filters-toolbar__action btn btn--primary h-35 bg-blumine"
          title="Download Excel relatórios de atendimentos"
          (click)="downloadExcel()"
        >
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button>
      </div>
    </div>
  </div>

  <div class="inline-block w-full mt-8">
    <app-list-attendance-reports
      [attendanceReports]="attendanceReports"
      [dadosPaginacao]="dadosPaginacao"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    ></app-list-attendance-reports>
  </div>

  <hr class="my-10" />
</div>
